<template>
  <Modal
    :visible="isModal"
    pop_tit="패치 접수 찾기"
    popSizeClass="popup__container--l"
    @close="closeModal"
  >
    <template #pop_content>
      <div class="search_form">
        <div class="modal-table__search end">
          <label for="search-keyword" class="sr-only"
            >검색어를 입력해주세요</label
          >
          <input
            type="text"
            id="search-keyword"
            placeholder="제목 또는 KVE로 검색"
            v-model="searchKeyword"
            @keyup.enter="performSearch"
          />
          <button
            type="button"
            class="btn btn--blue btn--m"
            @click="performSearch"
          >
            <i class="svg_icon icon_search white"></i>검색
          </button>
          <button
            type="button"
            class="btn btn--green btn--m"
            @click="downloadConfirm()"
          >
            조치확인서
          </button>
        </div>
      </div>
      <div class="board-wrapper">
        <div class="table-wrapper">
          <table class="board-list type-m-none-thead">
            <caption>
              패치 접수된 목록 조회
            </caption>
            <colgroup>
              <col width="10%" />
              <col width="20%" />
              <col width="40%" />
              <col width="15%" />
              <col width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">
                  <label class="chk">
                    <input type="checkbox" class="chk" v-model="isAllChecked" />
                  </label>
                </th>
                <th scope="col">KVE</th>
                <th scope="col">제목</th>
                <th scope="col">상태</th>
                <th scope="col">조치 요청 일자</th>
              </tr>
            </thead>
          </table>
          <div class="table-body-scroll">
            <table class="modal-table type-block--mobile">
              <caption>
                다운로드 가능한 인증서 조회
              </caption>
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col width="40%" />
                <col width="15%" />
                <col width="15%" />
              </colgroup>
              <tbody>
                <tr
                  v-for="(item, index) in filteredList"
                  :key="`${item.kve}-${index}`"
                >
                  <td class="chk-field">
                    <label class="chk"
                      ><input
                        type="checkbox"
                        class="chk"
                        :value="item.kve"
                        v-model="checkedItems"
                    /></label>
                  </td>
                  <td class="info-field">
                    {{ item.kve || "-" }}
                  </td>
                  <td class="tit-field">
                    <div class="ellipsis">{{ item.title || "-" }}</div>
                  </td>
                  <td class="info-field">
                    {{ convertStatusFormat(item.status) }}
                  </td>
                  <td class="info-field">
                    {{ convertDateFormat(item.regDate) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="filteredList == null || filteredList.length == 0"
              class="no-data"
            >
              {{
                isLoading
                  ? "데이터 조회중입니다. 잠시만 기다려주십시오."
                  : "검색 결과 없음..."
              }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #pop_buttons>
      <button
        type="button"
        class="btn btn--m btn--blue"
        @click="applySelection"
      >
        선택 완료
      </button>
    </template>
  </Modal>
</template>
<script>
import dt from "@/component/DateTime.js";
import Modal from "@/component/Modal.vue";
import { computed, inject, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  components: { Modal },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    submitType: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const saver = inject("filesaver");
    const axios = inject("axios");
    const store = useStore();

    // data 정의
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");
    const checkedItems = ref([]); // 선택된 항목의 kve 목록
    const searchKeyword = ref("");
    const patchRequestList = ref([]);

    // methods 정의
    const closeModal = () => {
      emit("close");
    };
    const getPatchRequestList = () => {
      patchRequestList.value = [];
      showLoading();
      // 패치 접수 찾기 목록 조회
      axios
        .post("/patch/pr/submission/patch-request/get", {
          status: props.submitType,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            patchRequestList.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const isAllChecked = computed({
      get() {
        return (
          filteredList.value.length > 0 &&
          checkedItems.value.length === filteredList.value.length
        );
      },
      set(value) {
        if (value) {
          // 필터링된 목록만 전체 선택
          checkedItems.value = filteredList.value.map((item) => item.kve);
        } else {
          checkedItems.value = [];
        }
      },
    });
    const convertDateFormat = (date) => {
      return dt.dateFormat(date);
    };
    const convertStatusFormat = (status) => {
      switch (status) {
        case "N":
          return "조치 계획서";
        case "F":
        case "E":
          return "조치 결과";
        default:
          return "접수 완료";
      }
    };

    const performSearch = () => {
      document.getElementById("search-keyword")?.blur();
    };

    const applySelection = () => {
      const selectedPatches = patchRequestList.value.filter((item) =>
        checkedItems.value.includes(item.kve)
      );
      emit("add", selectedPatches);
    };

    const downloadConfirm = () => {
      if (!checkedItems.value.length) {
        alert("선택된 항목이 없습니다.");
        return;
      }

      // showLoading();
      axios({
        method: "POST",
        url: "/patch/pr/submission/confirm/download",
        responseType: "blob",
        data: checkedItems.value,
      })
        .then((response) => {
          if (response.data.size === 0) {
            alert("해당 경로에 파일이 존재하지 않습니다.");
            return;
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          // KVE  새로운 파일명 생성
          const newFileName = `${checkedItems.value[0].kve}외_${checkedItems.length}건_조치확인서.zip`;
          saver.saveAs(blob, newFileName);
          checkedItems.value = [];
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          // hideLoading();
        });
    };

    // computed 정의
    const filteredList = computed(() => {
      //kve,제목 검색 기능
      if (!searchKeyword.value) {
        return patchRequestList.value;
      }
      const lowerCaseKeyword = searchKeyword.value.toLowerCase();
      return patchRequestList.value.filter(
        (item) =>
          (item.title ?? "").toLowerCase().includes(lowerCaseKeyword) ||
          (item.kve ?? "").toLowerCase().includes(lowerCaseKeyword)
      );
    });
    const isLoading = computed(() => store.state.loading.isLoading);

    // life cycle 정의
    onMounted(() => {
      checkedItems.value = [];
      getPatchRequestList();
    });

    // html에서 사용될 데이터 정의
    return {
      searchKeyword,
      filteredList,
      checkedItems,
      isAllChecked,
      convertStatusFormat,
      convertDateFormat,
      performSearch,
      closeModal,
      applySelection,
      isLoading,
      downloadConfirm,
    };
  },
};
</script>